import clamp from "lodash/clamp";
import { mapConfig } from "./map-config";

/**
 * Clamp X between min and max, accounting for scale
 * @param value [number]
 * @param zoom [number]
 */
export const constrainX = (value: number, zoom: number) => {
  const width = mapConfig.width * zoom;
  const left = width / 2;
  const right = -(width / 2) + window.innerWidth;

  return clamp(value, right, left);
};

/**
 * Clamp Y between min and max, accounting for scale
 * @param value [number]
 * @param zoom [number]
 */
export const constrainY = (value: number, zoom: number) => {
  const height = mapConfig.height * zoom;
  const top = height / 2;
  const bottom = -(height / 2) + window.innerHeight;

  return clamp(value, bottom, top);
};

/**
 * Clamp Z between min and max
 * @param value [number]
 */
export const constrainZ = (value: number) => {
  // Ignore min if zooming out too much causes the map to go out of bounds
  if (mapConfig.width * value <= window.innerWidth) {
    // Return the zoom level that would keep it in bounds
    return window.innerWidth / mapConfig.width;
  }
  if (mapConfig.height * value <= window.innerHeight) {
    // Return the zoom level that would keep it in bounds
    return window.innerHeight / mapConfig.height;
  }

  // Otherwise clamp to max or rmin
  return clamp(value, mapConfig.zoom.min, mapConfig.zoom.max);
};
